<template>
  <ConfirmationDialog v-bind="$props" ref="confirmationDialog" :buttonText="$t('actions.delete')" @execute="onConfirm">
    <template slot="content">
      <div class="confirmation-dialog__content">
        <i18n path="page.opportunity.delete-document-summary-item-confirmation">
          <template v-slot:action>
            <span class="confirmation-dialog__action">{{ $t('actions.delete') }}</span>
          </template>
        </i18n>
      </div>
    </template>
  </ConfirmationDialog>
</template>

<script>
import ConfirmationDialog from '@/components/page-admin-invites/ConfirmationDialog.vue';

export default {
  name: 'DocumentSummaryItemDeleteConfirmationPopup',
  components: { ConfirmationDialog },
  props: {},
  methods: {
    openDialog() {
      this.$refs.confirmationDialog.openDialog();
    },
    closeDialog() {
      this.$refs.confirmationDialog.closeDialog();
    },
    onConfirm() {
      this.$emit('on-confirm');
    },
  },
  emits: ['on-confirm'],
};
</script>

<style scoped lang="scss"></style>
